module.exports = __webpack_public_path__ + "media/images/icons/icon-explore-calendar-305bd4127dd803c2ec41020c7b95d9cf.svg";